import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
/** Multiple Language imports **/
import { Translate } from "react-localize-redux";
/** End of Multiple Language imports **/
import ApiCalls from "../../custom-classes/api-calls";
import FormGroupPlan from '../forms/form-group-plan';
/**
 * Modal for update a plan
 */
class ModalPlans extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            visible: this.props.visible,
            isEdit: this.props.isEdit,
            planId: this.props.planId
        };
        this.toggle = this.toggle.bind(this);
    }

    componentDidMount(){
        if(this.state.planId !== null)
            this.doSearch();
    }

    /**
     * Hide or shows the window
     */
    toggle() {
        this.setState({
            visible: !this.state.visible
        });
        // Updates the parent (send it owns to state to update it)
        this.props.updateParent(!this.state.visible);
    }

    /**
     * Call the results to display
     */
    doSearch() {
        this.setState({
            loading: true
        });

        let apiCall = ApiCalls.getPlansAdvanced(this.state.planId,
            null, null, 1, 1, true);
        apiCall.then((data)=> {
            let Plan = data.Plans.Plans[0];

            // Prepare the descriptions
            let planDescriptionArray = [];
            for(let i=0; i < Plan.PlanDescriptionByLang.length;i++)
            {
                planDescriptionArray.push({
                    langCode: Plan.PlanDescriptionByLang[i].LangCode,
                    title: Plan.PlanDescriptionByLang[i].Name,
                    description: Plan.PlanDescriptionByLang[i].Description
                })
            }

            // Prepare taxes
            let planTaxes = [];
            for(let i=0; i < Plan.PlanTaxes.length;i++)
            {
                planTaxes.push(Plan.PlanTaxes[i].TaxId);
            }

            // Prepare the countries
            let countriesSelected = [];
            let regionsSelected = [];

            for(let i=0; i < Plan.PlanAvailableIsos.length; i++)
            {
                if(Plan.PlanAvailableIsos[i].StateIso !== null){
                    regionsSelected.push(Plan.PlanAvailableIsos[i].StateIso + "|" + Plan.PlanAvailableIsos[i].CountryIso);
                    continue; // Continue. Do not add the country alone.
                }

                if(Plan.PlanAvailableIsos[i].CountryIso !== null)
                    countriesSelected.push(Plan.PlanAvailableIsos[i].CountryIso);
            }

            this.setState({
                currencyIsoCode: Plan.Currency,
                interval: Plan.Interval,
                productId: Plan.ProductId,
                planName: Plan.Name,
                price: Plan.Amount,
                validPrice: true,
                tryPeriod: Plan.TrialDays,
                isForSchoolChecked: Plan.IsForSchool === "1",
                isPrivate: Plan.IsPrivate === "1",
                studentQuantity: Plan.ProfilesQuantity,
                validStudentQuantity: true,
                isAvailableChecked: Plan.Available === "1",
                taxesSelected:  planTaxes, // Prepare taxes object
                planDescriptionDetails:  planDescriptionArray,
                validDescriptions: true,
                planAvailableIsos: [], // Prepare object
                checkedValues: countriesSelected, // Set checked countries
                checkedRegionsValues: regionsSelected, // Set checked regions
                planId: Plan.Id,
                disabledGenerics: true,
                disabledPlanName: false,
                disabledPlanForSchools: false,
                disabledPrivatePlan: false,
                disabledProfilesQuantity: false,
                disabledPlanAvailability: false,
                disabledPlanDescriptions: false,
                disabledRegionCountryIsos: false
            });
            this.setState({
                loading: false,
            });
        });
    }

    // Render a generic modal. The body text should be sent in the text
    render() {
        return (
            <div>
                <Modal isOpen={this.state.visible} toggle={this.toggle} className="modal-results">
                    <ModalHeader toggle={this.toggle}>
                    </ModalHeader>
                    <ModalBody>
                        <FormGroupPlan data={this.state} updateParent={this.handlePlanCreated}/>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.toggle}>
                            <Translate id="general.close"/>
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default ModalPlans;